<template>
  <a-modal v-model="showModal" :footer="null" class="mobile-modal-fullscreen" :closable="false">
    <div class="d-flex align-items-center web-abs mb-4">
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="hide" />
      <h4 class="fw700 font24 gray700 mb-0 show-in-mobile">Reactions</h4>
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto cp font20" @click="hide" />
    </div>
    <div class="d-flex">
      <div class="cp px-2 pb-1" @click="changeCurrentTab('all')" :style="{ 'border-bottom': currentTab === 'all' ? '2px solid ' + (getPrimaryColor() || '#2A71D4 !important') : 'none' }">All</div>
      <div
        v-for="reaction in totalReactions"
        :key="reaction"
        class="cp ml-3 pl-2 pb-1"
        @click="changeCurrentTab(reaction)"
        :style="{ 'border-bottom': currentTab === reaction ? '2px solid ' + (getPrimaryColor() || '#2A71D4 !important') : 'none' }"
      >
        <img :src="getReactionIcon(reaction)" alt="" class="hw20 mr-1" />
        {{ getArrayLength(reaction) }}
      </div>
    </div>

    <div class="d-flex flex-column" v-if="getArrayLength(currentTab)">
      <template v-if="currentTab === 'all'">
        <div v-for="eachEmoji in availableReactions" :key="eachEmoji">
          <div v-for="eachUser in getArray(eachEmoji)" :key="eachUser.id" class="fw700 d-flex align-items-center mt-4 text-capitalize">
            <a-badge v-if="eachUser.url" :offset="[-5, 35]" class="mr-4" @click="viewProfile(eachUser)">
              <template #count>
                <img :src="getReactionIcon(eachEmoji)" alt="" class="hw20" />
              </template>
              <img class="rounded-circle cp hw40" :src="eachUser.url" alt="reaction dp" />
            </a-badge>
            <a-badge v-else :offset="[-5, -5]" class="mr-4" @click="viewProfile(eachUser)">
              <template #count>
                <img :src="getReactionIcon(eachEmoji)" alt="" class="hw20" />
              </template>
              <div class="rounded-circle cp hw40 flex-center-center font27 font-white" :style="{ 'background-color': getPrimaryColor() }">
                {{ getInitials(eachUser) }}
              </div>
            </a-badge>
            {{ getName(eachUser) }}
          </div>
        </div>
      </template>
      <template v-else>
        <div v-for="user in getArray(currentTab)" :key="user.id" class="fw700 d-flex align-items-center mt-4 text-capitalize">
          <a-badge :offset="[-5, 35]" class="mr-4" @click="viewProfile(user)" v-if="user.url">
            <template #count>
              <img :src="getReactionIcon(currentTab)" alt="emoji" class="hw20" />
            </template>
            <img class="rounded-circle cp hw40" :src="user.url" alt="reaction dp" />
          </a-badge>

          <a-badge :offset="[-5, -5]" class="mr-4" @click="viewProfile(user)" v-else>
            <template #count>
              <img :src="getReactionIcon(currentTab)" alt="emoji" class="hw20" />
            </template>
            <div class="rounded-circle cp hw40 flex-center-center font27 font-white" :style="{ 'background-color': getPrimaryColor() }">
              {{ getInitials(user) }}
            </div>
          </a-badge>
          {{ getName(user) }}
        </div>
      </template>
    </div>
    <div class="mt-4 text-center" v-else>No Reactions</div>
  </a-modal>
</template>

<script>
export default {
  props: {
    postProp: Object,
  },
  data() {
    return {
      totalReactions: ["likes", "hugs", "happy", "angry", "sad"],
      showModal: false,
      currentTab: "all",
      post: {},
      availableReactions: [],
    }
  },
  created() {
    let arr = []
    this.totalReactions.forEach(reaction => (arr = arr.concat(eval(`this.postProp.${reaction}_reacted_users`))))
    this.post = { ...this.postProp, all_reacted_users: arr }
    this.availableReactions = this.totalReactions.filter(emoji => eval(`this.postProp.${emoji}_reacted_users.length`))
    // console.log(this.postProp, this.post, "in created ")
  },
  mounted() {
    let arr = []
    this.totalReactions.forEach(reaction => (arr = arr.concat(eval(`this.postProp.${reaction}_reacted_users`))))
    this.post = { ...this.postProp, all_reacted_users: arr }
    this.availableReactions = this.totalReactions.filter(emoji => eval(`this.postProp.${emoji}_reacted_users.length`))
    // console.log(this.postProp, this.post, "in mounted ")
  },
  methods: {
    getInitials(user) {
      let f = "D",
        l = ""
      f = user.display_name ? user.display_name[0] : "D"
      l = user.display_name.split(" ").slice(1).join(" ") ? user.display_name.split(" ").slice(1).join(" ")[0] : ""
      return f.toUpperCase() + l.toUpperCase()
    },
    getName(user) {
      return user.display_name || "~No Name~"
    },
    show() {
      this.showModal = true
    },
    hide() {
      this.showModal = false
    },
    changeCurrentTab(tab) {
      this.currentTab = tab
    },
    getReactionIcon(val) {
      let value = ""
      switch (val) {
        case "like":
        case "likes":
          value = "like"
          break
        case "embrace":
        case "hugs":
        case "heart":
          value = "embrace"
          break
        case "emotional":
        case "sad":
          value = "emotional"
          break
        case "haha":
        case "happy":
          value = "happy"
          break
        case "angry":
          value = "angry"
          break
        default:
          value = "like"
      }
      return require(`../../../assets/emojis/${value}-40.png`)
    },
    getArray(arr) {
      return eval(`this.post.${arr}_reacted_users`)
    },
    getArrayLength(arr) {
      return eval(`this.post.${arr}_reacted_users.length`)
    },
  },
  // computed: {
  //   all_reacted_users() {
  //     // let count = 0;
  //     // this.totalReactions.forEach(
  //     //   reaction => (count = count + eval(`${reaction}_reacted_users.length`))
  //     // );
  //     // return count
  //     let arr = [];
  //     this.totalReactions.forEach(
  //       reaction =>
  //         (arr = [...(arr + eval(`this.post.${reaction}_reacted_users`))])
  //     );
  //     return arr;
  //   }
  // }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  .ml-3 {
    margin-left: 0.5rem !important;
  }
}
@media screen and (min-width: 600px) {
  .web-abs {
    position: absolute;
    right: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/activity/Reactions.vue